import { Button, Stack, styled } from '@mui/material';
import { StyledAlert } from 'components/Toast/Toast.styled';

export const ToastsStack = styled(Stack)(({ theme }) => ({
  position: 'fixed',
  bottom: 24,
  left: 24,
  zIndex: theme.zIndex.snackbar,
  gap: 8,
  maxWidth: '60%',
}));

export const UndoAlert = styled(StyledAlert)({
  alignItems: 'center',
  '.MuiAlert-action': {
    alignItems: 'center',
    gap: 4,
    paddingTop: 0,
  },
});

export const UndoButton = styled(Button)({
  color: '#FFFFFF',
  border: '1px solid rgba(255, 255, 255, 0.6)',
  borderRadius: 4,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: '22px',
  textTransform: 'none',
  padding: '1px 12px',
  minWidth: 'auto',
  whiteSpace: 'nowrap',
  '&:hover': {
    border: '1px solid #FFFFFF',
    background: 'rgba(255, 255, 255, 0.12)',
  },
});
